module.exports = __webpack_public_path__ + "02_very_short_yellow.b1b06b16.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/boy/layer5/02_very_short_yellow.png
// module id = Mg/g
// module chunks = 0